import { Button, Image, TextButton } from '@wix/design-system'
import { useContent } from '@wix/funnel-builder-lizard'
import { ArrowBentUpLeftFilled } from '@wix/wix-ui-icons-common'
import classNames from 'classnames'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { useNext } from '../../../hooks/useNext'
import { DesignSystemTokensLoader } from '../../reusable/DesignSystemTokensLoader'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import { OldUserSplitScreenContent } from './OldUserSplitScreen.content'
import s from './OldUserSplitScreen.scss'

export const OldUserSplitScreen: FC = () => {
  const { content } = useContent<OldUserSplitScreenContent>()
  const next = useNext()

  const pageLogger = usePageLogger()

  const { question, secondaryQuestion } = content
  const { questionKey, options } = question
  const [createOption, existingOption] = options
  const [navOption] = secondaryQuestion.options

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleOptionClick = (optionKey: string) => {
    void pageLogger.answer({ answer: optionKey })
    next({ [questionKey]: { values: [optionKey] } })
  }

  const handleNavClick = () => {
    void pageLogger.answer({ answer: navOption.optionKey })
    next({ [secondaryQuestion.questionKey]: { values: [navOption.optionKey] } })
  }

  return (
    <DesignSystemTokensLoader type="odeditor">
      <div className={s.page}>
        <div className={s.header}>
          <WixLogo className={s.logo} />
          <div className={s.navigateBtn}>
            <TextButton skin="dark" onClick={handleNavClick}>
              {navOption.label}
            </TextButton>
          </div>
        </div>

        <div className={s.content}>
          <span className={s.subtitle}>{content.subtitle}</span>
          <span className={s.title}>{content.title}</span>
          <div className={s.card}>
            <div className={s.imagesContainer}>
              <div className={classNames(s.imageCard, s.imageLeft)}>
                <Image className={s.image} src={content.leftSrc} alt={content.leftAlt ?? ''} />
              </div>
              <div className={classNames(s.imageCard, s.imageRight)}>
                <Image className={s.image} src={content.rightSrc} alt={content.rightAlt ?? ''} />
              </div>
              <div className={classNames(s.imageCard, s.imageCenter)}>
                <Image className={s.image} src={content.centerSrc} alt={content.centerAlt ?? ''} />
              </div>
            </div>
            <div className={s.cardTexts}>
              <span className={s.cardTitle}>{content.cardTitle}</span>
              <span className={s.cardSubtitle}>{content.cardSubtitle}</span>
            </div>
            <Button
              skin="standard"
              priority="primary"
              size="medium"
              onClick={() => handleOptionClick(createOption.optionKey)}
            >
              {createOption.label}
            </Button>
          </div>
          <div className={s.textButtonWrapper}>
            <TextButton skin="dark" underline="always" onClick={() => handleOptionClick(existingOption.optionKey)}>
              {existingOption.label}
            </TextButton>
          </div>
        </div>
      </div>
    </DesignSystemTokensLoader>
  )
}
